/**
 * A "machine value" is a string with no wrap opportunity -- an Azure resource
 * path, a GUID, a content hash -- long enough that it will push past its
 * container rather than wrap inside it.
 *
 * Detail cards give each value a bounded column. A normal sentence wraps at its
 * spaces and stays inside; a 130-character resource id has no space to break
 * at, so it overflows the card. Those are exactly the values that want
 * monospace, single-line truncation and a copy button.
 *
 * The threshold is deliberately above a GUID (36) and above the identifiers
 * this app shows in full -- a 24-character Mongo id reads fine untruncated, and
 * turning it monospace with a copy button would be noise.
 */
export const LONG_MACHINE_VALUE_MIN_LENGTH = 40;

export const isLongMachineValue = (value) =>
  typeof value === "string" &&
  value.length >= LONG_MACHINE_VALUE_MIN_LENGTH &&
  !/\s/.test(value);
